if (!window.beaePageJS) {
                                    window.beaePageJS = [];
                                }
                                let jsHandle_637aa33d401d670b9237efa2 = () => {
                    if (document.querySelector('.beae-kj7nf7f8:not([data-beae-bind])')) {
                        (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                            $el: document.querySelector('.beae-kj7nf7f8:not([data-beae-bind])'),
                            
                            id: 'beae-kj7nf7f8',
                            isLive: true
                        });
                        document.querySelector('.beae-kj7nf7f8:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                    }
                }
                                if (window.beaejQuery) {
                                    jsHandle_637aa33d401d670b9237efa2()
                                } else {
                                    window.beaePageJS.push(jsHandle_637aa33d401d670b9237efa2)
                                }